import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {DashboardService} from '../../../service/events/dashboard.service';
import {ClientesApiService} from '../../../service/api/clientes-api.service';
import {InputType} from '../../../common/components/form-builder/form-builder.component';
import {RequestButtonTypes} from '../../../common/components/request-button/request-button.component';
import {RequestHandler} from '../../../service/OffService/request-handler';
import {BaseView} from '../../base-view';
import {StorageManager} from '../../../common/storage-manager.class';
import {Subscription} from 'rxjs';
import {Filtering} from '../../../service/filtering/filtering';
import {build, stack} from '../../../common/classes/request-builder';
import {FincasApiService} from '../../../service/api/fincas-api.service';
import { environment } from '../../../../environments/environment';
import { SdiApiService } from '../../../service/api/sdi.service';
import { Utils } from '../../../common/utils';
import { createCsv } from '../../../common/components/reactive-form-builder/export/createCsv';
import type { OnInit } from '@angular/core';
import type { ItemInterface } from '../../../common/components/form-builder/form-builder.component';
import { ClienteModel } from '../../../models/cliente.model';
import { UserModel } from '../../../models/usuarios/user.model';
import { ColInterface } from '../../../common/components/common-list-table/col.interface';
import { ColStylesInterface } from '../../../common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { ClientesEnvironmentDefinition } from './environment-variables';
import { ClientesFormDefinition } from './clientes-form/form-definition';
import { FormType } from '../../../common/components/reactive-form-builder/interfaces/form.interface';
import { ClientesListsDefinition } from './clientes-form/list-variables';

@Component({
    selector: 'app-clientes',
    standalone: false,
    templateUrl: './clientes.component.html',
    styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent extends BaseView<ClienteModel> implements OnInit {
    public form!: ClientesFormDefinition;
    public env: ClientesEnvironmentDefinition = new ClientesEnvironmentDefinition();
    public lists: ClientesListsDefinition = new ClientesListsDefinition();

    public getRequest: RequestHandler<ClienteModel[]> = this.clientesApi.clientesGET;
    public getRequestSdi: RequestHandler<ClienteModel[]> = this.sdiApi.SdiClientesGET;
    public deleteRequest: RequestHandler<ClienteModel> = this.clientesApi.clientesDELETE;
    public currentClient: ClienteModel = StorageManager.getClient() || {};
    public currentUser: UserModel = StorageManager.getUser() || {};
    public deleteWarningMessage = '';
    public deleteWarning = '';

    public user = StorageManager.getUser();

    public componentName = 'clientes';

    public sub: Subscription = new Subscription;
    public filter: Filtering<ClienteModel> = new Filtering<ClienteModel>();

    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public generarFields: ItemInterface<object>[] = [
        {
            field: 'fecha_inicio',
            label: 'Fecha inicio',
            inputType: { type: InputType.CALENDAR }
        },
        {
            field: 'fecha_fin',
            label: 'Fecha fin',
            inputType: { type: InputType.CALENDAR }
        }
    ];


    public cols: ColInterface[] = [
        {field: 'nombre', header: 'Nombre o Razón Social', filter: '', width: '200px'},
        {field: 'apellido_1',header: 'Apellido' },
        {field: 'direccion', header: 'Dirección', filter: '',  visible: this.env.appName !== 'avafitogest'},
        {field: 'nif', header: 'NIF\xa0/\xa0CIF', filter: ''},
        {field: 'localidad', header: 'Localidad', filter: ''},
        {field: 'email', header: 'Email', filter: '', width: '200px'},
        {field: 'usuario_asignado_nombre', header: 'Técnico', filter: '', visible: this.env.showTecnicoAsignado},
        {field: 'observaciones', header: 'Observ.', filter: '', visible: this.env.showClientesObservaciones, width: '40px'},
        {field: 'cooperativa', header: 'Cooperativa', visible: this.env.showClientesCooperativa},
        {field: 'tipo', header: 'Tipo', visible: this.env.appName === 'agrosalvi'},
    ];

    public colsSdi: ColInterface[] = [
        {field: 'nomcli', header: 'Nombre', filter: '', width: '160px'},
        {field: 'razon', header: 'Razón', filter: '', width: '160px'},
        {field: 'nifcli', header: 'NIF', filter: ''},
        {field: 'dircli', header: 'Dirección', filter: ''},
        {field: 'dtocli', header: 'Dto.', filter: '', width: '60px'},
        {field: 'nomprovi', header: 'Provincia', filter: ''},
        {field: 'pobcli', header: 'Población', filter: ''},
        {field: 'telcli', header: 'Teléfono', filter: ''},
        {field: 'email', header: 'Email', filter: '', width: '160px'}
    ];

    constructor(private router: Router,
        private dashboard: DashboardService,
        public clientesApi: ClientesApiService,
        public sdiApi: SdiApiService,
        public fincasApi: FincasApiService
    ) {
        super(dashboard, clientesApi.clientesGET, clientesApi.clientesDELETE);
    }


    ngOnInit() {
        this.dashboard.setMenuItem('clientes');
        this.dashboard.changeClientActive = true;
        this.sub = this.dashboard.onChangeClient()
            .subscribe(() => {
                this.currentClient = StorageManager.getClient();
            });

        this.initData();
        this.initFilter();
    }

    public filterClients() {
        this.filter.filter();
    }

    public selectClient(data: ClienteModel) {
        StorageManager.saveClient(data);
        this.dashboard.emitClientChange();
    }

    public add() {
        this.router.navigate(['dashboard', 'crear-cliente']);
    }

    public edit(data: ClienteModel) {
        this.router.navigate(['dashboard', 'editar-cliente', data.id, data]);
    }

    public checkIfDeletedClientWasSelected(clientId: string) {
        const clientSelected = StorageManager.getClient();

        if ((clientSelected || {}).id === clientId) {
            StorageManager.deleteClient();
            this.dashboard.emitClientChange();
        }
    }

    public override deleteRegister() {
        if (this.model.id) {
            const fincaCliente = (this.lists.fincas.values || [])
                .filter(it => it && it.value)
                .map(it => it.value)
                .find(finca => finca.id_cliente === this.model.id);

            if (!fincaCliente || this.deleteWarning) {
                this.deleteWarning = '';
                this.deleteWarningMessage = '';
                this.checkIfDeletedClientWasSelected(this.model.id);

                this.deleteRequest.safePerform(this.model);
                this.deleteRequest.response(() => {
                    if (!this.deleteRequest.hasError) {
                        this.getRequest.safePerform();
                    }
                });
            } else {
                this.deleteWarningMessage = 'El cliente tiene datos, se borrara toda la información asociada';
                this.deleteWarning = '¡Cliente con datos! ¿Continuar?';
            }
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    /**
     * Aligns to center some fields text. 
     * @param _value 
     * @param col 
     * @returns 
     */
    public globalConditionalStyle(_value: string, col: ColInterface): ColStylesInterface {
        if (
            col.field === 'observaciones' || 
            col.field === 'localidad' || 
            col.field === 'usuario_asignado_nombre' || 
            col.field === 'nif'
        ) {
            return {
                textAlign: 'center'
            };
        }// if();
        return {};
    }// ();

    /**
     * Displays in the table if there's some observaciones regarding the client and concatenates name and surname.
     * @param value 
     * @param col 
     * @param row 
     * @returns 
     */
    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<ClienteModel>) {
        switch(col.field) {
            case 'observaciones':
                return value ? 'Sí' : '';
            case 'nombre': { 
                const cliente = row.data as ClienteModel;

                /* Se concatena nombre y apellidos en el 'return' porque, en Agricar, esta función se ejecuta,
                    por algún motivo que desconocemos, cada vez que se hace una iteracción en la sección.
                */
                return cliente.razon_social
                    ? cliente.razon_social
                    : cliente.nombre + ' ' + (cliente.apellidos ?? ''); 
            }// case 'nombre';
            default:
                return value;
        }// switch();
    }// ();

    /**
     * Displays a popup with full info
     * @param modal Popup name.
     * @param data Cliente info.
     */
    public override show(modal: string, data: ClienteModel) {
        super.show(modal, data);
        this.form = new ClientesFormDefinition(+FormType.INFORMATIVE, data as Record<string,string>, null);
    }

    /**
     * 
     * @param modal Name of the popup to hide.
     */
    public override hide(modal: string) {
        this.model = {} as ClienteModel;
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    /**
     * Performs a backup of all data regarding the client.
     */
    public async exportarClientes() {
        window.location.replace(environment.serverUrl + 'fito_backup/exportar_clientes.php');
    }// ();


    /**
     * Exports client data as introduced in the client form.
     */
    public async downloadCsv() {
        this.form = new ClientesFormDefinition(
                    +FormType.EXPORT, 
                    this.filtering.value as unknown as Record<string,string>, 
                    null,
        );
        
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as ClienteModel[]);

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (csvLink) {
            csvLink.download = 'Clientes.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }// if();
    }// ();

    /**
     * Generates Cuaderno de Campo for that client in particular.
     * @param informe_tratamientos 
     * @param libro_fertilizantes 
     * @returns 
     */
    public generarCuaderno(informe_tratamientos = false, libro_fertilizantes = false) {
        if (!this.model.fecha_inicio || !this.model.fecha_fin) {
            alert('Debe especificar un intervalo de fechas.');
            return;
        }
        const cliente = this.model.nombre;
        const idCliente = this.model.id_cliente;
        const appName = this.env.appName;
        const user = StorageManager.getUser().id;

        let cuadernoFields = '?cliente=' + cliente +
        '&id_cliente=' + idCliente +
        '&app_name=' + appName +
        '&id_user=' + user;

        const interval: {fechaInicio: string, fechaFin: string, anyo: string} =
            this.getDates(this.model.fecha_inicio, this.model.fecha_fin);
        const fechaFin = interval.fechaFin;
        const fechaInicio = interval.fechaInicio;
        const anyo2 = interval.anyo;
        cuadernoFields += '&fecha_fin=' + fechaFin +
        '&fecha_inicio=' + fechaInicio + '&anyo=' + anyo2;

        if (informe_tratamientos) {
            cuadernoFields += '&informe_tratamientos=true';
        }
        if (libro_fertilizantes) {
            cuadernoFields += '&libro_fertilizantes=true';
        }
        window.open((this.env.serverUrl + 'ws/informes/index.php' + cuadernoFields), '_blank');
    }

    public getDates(inicio: string | Date, fin: string | Date): {fechaInicio: string, fechaFin: string, anyo: string} {
        const fechaInicio = (inicio instanceof Date) ? Utils.formatDate(inicio) : inicio;
        const fechaFin = (fin instanceof Date) ? Utils.formatDate(fin) : fin;

        // Si no hay año se calcula con los años de la fecha de inicio y de fin (2017-2018)
        let anyo = fechaInicio.split('/')[2] ?? '';
        anyo = fechaInicio.split('/')[2] + '-' + fechaFin.split('/')[2];
        if (fechaInicio.split('/')[2] === fechaFin.split('/')[2]) { anyo = fechaInicio.split('/')[2] ?? ''; }

        return {fechaInicio, fechaFin, anyo};
    }

    /**
     * Switches between displaying all clients or only the one associated to the user.
     */
    public changeShowAll(){
        sessionStorage.setItem('showAllclientes', this.env.showAllClients === true ? 'true' : 'false' );
    }// ();


    /**
     * Filters data displayed in the table.
     */
    private initFilter() {
        if (this.env.appName === 'benibal' || this.env.appName === 'avafitogest') {
            this.filter.addFilter((data: TreeNode<ClienteModel>[] | void) => (data || [])
                .filter((it: TreeNode<ClienteModel>) => it)
                .filter((it: TreeNode<ClienteModel>) => !this.env.clientesMostrarTodosDefault
                    ? it.data?.acceso_plataforma === 1
                    : true)
            );
        } else if (this.env.appName === 'agrosalvi'){
            if (this.currentUser.tipo !== 'Agro + Garden'){
                this.filter.addFilter((data: TreeNode<ClienteModel>[] | void) => (data || [])
                    .filter((it: TreeNode<ClienteModel>) => it)
                    .filter((it: TreeNode<ClienteModel>) => !this.env.showAllClients
                        ? this.currentUser.tipo === it.data?.tipo
                        : true)
                );
            }
        } else {
            this.filter.addFilter((data: TreeNode<ClienteModel>[] | void) => (data || [])
                .filter((it: TreeNode<ClienteModel>) => it)
                .filter((it: TreeNode<ClienteModel>) => !this.env.showAllClients
                    ? [it.data?.id_usuario_asignado, it.data?.id_usuario_asignado2].includes(this.currentUser.id)
                    : true)
            );
        }

        if (this.env.appName === 'innovia' && this.currentUser.rol === 'user'){
            this.filter.addFilter((data: TreeNode<ClienteModel>[] | void) => (data || [])
                .filter((it: TreeNode<ClienteModel>) => it)
                .filter((it: TreeNode<ClienteModel>) => this.currentUser.id_cliente === it.data?.id)
            );
        }// if();
    }// ();

    /**
     * Retrieves all finca data.
     */
    private initData() {
        stack([
            build(this.fincasApi.fincasGET, this.lists.fincas, '', true)
        ]);
    }// ();
}// class;